// extracted by mini-css-extract-plugin
module.exports = {"content":"cardHistory_content__2X2Kt","round__user":"cardHistory_round__user__Bqu4v","__start":"cardHistory___start__2J9jy","__button":"cardHistory___button__2XzZF"};